import { IMessage } from '@eventr/common'
import { ColoursObj, Icon, Typography } from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import { defaultAddSnack } from '../../../../state/overlayState/overlayContext'
import { useChatBodyContext } from '../chatProvider'

interface IDownloadTypeMessageProps {
    message: IMessage
}
export function DownloadTypeMessage({ message }: IDownloadTypeMessageProps) {
    const { api, getDownloadUrl } = useChatBodyContext()

    if (api.value.chatApi) {
        return (
            <a
                href={getDownloadUrl(
                    api.value.chatApi.host + message?.attachments[0]?.title_link
                )}
                download
            >
                <Stack spacing={'8px'} direction={'row'} alignItems={'center'}>
                    <Box
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        width={'48px'}
                        height={'48px'}
                        borderRadius={'4px'}
                        bgcolor={ColoursObj.backgrounds.primary}
                    >
                        <Icon name="Document" width="24px" height="24px" />
                    </Box>
                    <Typography variant="bodyBold">
                        {message.file.name}
                    </Typography>
                </Stack>
            </a>
        )
    } else {
        return (
            <Stack
                spacing={'8px'}
                direction={'row'}
                alignItems={'center'}
                onClick={() => {
                    defaultAddSnack(
                        'Could not get download, please try again later',
                        'warning'
                    )
                }}
            >
                <Box
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}
                    width={'48px'}
                    height={'48px'}
                    borderRadius={'4px'}
                    bgcolor={ColoursObj.backgrounds.primary}
                >
                    <Icon name="Important" />
                </Box>
            </Stack>
        )
    }
}
